import { createFeature, createReducer, on } from '@ngrx/store';
import { createAction, props } from '@ngrx/store';
import { Student, StudentFilters, StudentListResponse } from '../models/student.models';

// Actions
export const StudentActions = {
  loadStudents: createAction('[Student] Load Students'),
  loadStudentsSuccess: createAction(
    '[Student] Load Students Success',
    props<{ students: Student[] }>()
  ),
  loadStudentsFailure: createAction(
    '[Student] Load Students Failure',
    props<{ errorMessage: string }>()
  )
};

// State
interface StudentState {
  students: Student[];
  isLoading: boolean; // ✅ Positive boolean naming
  errorMessage: string | null;
}

const INITIAL_STATE: StudentState = {
  students: [],
  isLoading: false,
  errorMessage: null
};

// Reducer with early returns pattern
export const studentFeature = createFeature({
  name: 'students',
  reducer: createReducer(
    INITIAL_STATE,
    on(StudentActions.loadStudents, (currentState) => ({
      ...currentState,
      isLoading: true,
      errorMessage: null
    })),
    on(StudentActions.loadStudentsSuccess, (currentState, { students }) => ({
      ...currentState,
      students,
      isLoading: false
    })),
    on(StudentActions.loadStudentsFailure, (currentState, { errorMessage }) => ({
      ...currentState,
      errorMessage,
      isLoading: false
    }))
  )
}); 